import React from 'react';

const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-start gap-3 mb-4 animate-fade-in">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-dev-accent/10 border border-dev-accent/30 flex items-center justify-center">
        <span className="text-xs font-mono font-bold text-dev-accent">T</span>
      </div>
      <div className="bg-dev-bg-card border border-dev-border rounded-2xl rounded-tl-sm px-4 py-3 max-w-[80%]">
        <div className="flex gap-1.5">
          <span className="w-2 h-2 bg-dev-text-muted rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-dev-text-muted rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-dev-text-muted rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
